<script setup lang="ts">
import { FormInputStrings } from "../types";
import { eventBus } from "../event_bus";
import { useI18n } from "vue-i18n";
import { toast } from "vue3-toastify";

/////////////////////////////////////////////////////////////
//////////////////////// PROPS //////////////////////////////
/////////////////////////////////////////////////////////////
const { t } = useI18n();
const props = defineProps<{
  config: FormInputStrings;
  modelValue: string[];
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string[]): void;
}>();
/////////////////////////////////////////////////////////////
////////////////////// VARIABLES /////////////////////////////
/////////////////////////////////////////////////////////////
const inputValue = ref<string>("");

/////////////////////////////////////////////////////////////
////////////////////// COMPUTED /////////////////////////////
/////////////////////////////////////////////////////////////
const value = computed({
  get: () => props.modelValue,
  set: (value: string[]) => {
    emit("update:modelValue", value);
    eventBus.emit(`form.update.${props.config.name}`);
  },
});

/////////////////////////////////////////////////////////////
////////////////////// METHODS //////////////////////////////
/////////////////////////////////////////////////////////////
function addValue() {
  if (inputValue.value) {
    if (props.config.validator) {
      const errorMessage = props.config.validator(inputValue.value);
      if (errorMessage) {
        toast.error(t(errorMessage));

        inputValue.value = "";
        return;
      }
    }

    if (props.config.unique) {
      if (value.value.includes(inputValue.value)) {
        toast.error(t("Value already exists"));

        inputValue.value = "";
        return;
      }
    }

    if (props.config.formatter) {
      inputValue.value = props.config.formatter(inputValue.value);
    }

    value.value.push(inputValue.value);
    inputValue.value = "";
  }
}

/////////////////////////////////////////////////////////////
////////////////////// HOOKS ////////////////////////////////
/////////////////////////////////////////////////////////////
</script>

<template>
  <AppTextField
    v-model="inputValue"
    v-bind="config"
    :placeholder="$t('Input text and press enter to add a value')"
    :disabled="disabled || config.disabled"
    :label="config.label ? $t(config.label) : undefined"
    @blur="addValue"
    @keydown.enter="addValue"
  />
  <VRow>
    <VCol>
      <VChip v-for="v in value" class="mr-2 mt-2">
        {{ v }}
        <VIcon class="ml-1" @click="value.splice(value.indexOf(v), 1)"
          >tabler-x</VIcon
        >
      </VChip>
    </VCol>
  </VRow>
</template>
